import * as React from 'react';

import { styled } from '@mui/material/styles';
import { tableCellClasses, TableCell, TableContainer, Table, TableHead, TableRow, TableBody } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { ShuttleInfo } from './type';

// ********************************************************************************
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#F3F2F5',
    color: '#3F2A55',
    fontFamily: 'Gotham-Bold',
  },
  [`&.${tableCellClasses.body}`]: {
    fontFamily: 'Gotham-Medium',
  },
  fontSize: 12,
  maxWidth: '100px',
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(even)': {
    backgroundColor: '#F3F2F5',
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

type Props = { routes: ShuttleInfo[] };
export const ShuttleRouteTable: React.FC<Props> = ({ routes }) => {
  const { t } = useTranslation();
  const headers = [
    t('shuttle_service.shuttle_price.table.location'),
    t('shuttle_service.shuttle_price.table.address'),
    // t('shuttle_service.shuttle_price.table.price'),
    t('shuttle_service.shuttle_price.table.nb_schedule'),
    t('shuttle_service.shuttle_price.table.sb_schedule'),
    t('shuttle_service.shuttle_price.table.nb_times'),
    t('shuttle_service.shuttle_price.table.sb_times'),
  ];

  // == Render =====================================================================
  return (
    <TableContainer>
      <Table aria-label="shuttle table" size="small">
        <TableHead>
          <TableRow>
            {headers.map((header, index) => (
              <StyledTableCell key={index}>{header}</StyledTableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {routes.map((row) => (
            <StyledTableRow key={row.location}>
              <StyledTableCell component="th" scope="row" sx={{ minWidth: '130px' }}>
                {row.location}
              </StyledTableCell>
              <StyledTableCell sx={{ minWidth: '220px' }}>{row.address}</StyledTableCell>
              {/* <StyledTableCell sx={{ maxWidth: '60px' }}>
                {row.price === 0 ? '-' : `$${row.price.toFixed(2)}`}
              </StyledTableCell> */}
              <StyledTableCell
                sx={{
                  whiteSpace: 'nowrap',
                }}
              >
                {row.nbSchedule}
              </StyledTableCell>
              <StyledTableCell
                sx={{
                  whiteSpace: 'nowrap',
                }}
              >
                {row.sbSchedule}
              </StyledTableCell>
              <StyledTableCell>{row.nbTime}</StyledTableCell>
              <StyledTableCell>{row.sbTime}</StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
